import React, {useState} from 'react'
import {maxWidth} from '../common/StyleValue'
import HowtoBox from '../trias/HowtoBox'
import Startgrant from '../trias/Startgrant'
import styled from 'styled-components';

const GuideStyle = styled.div`
  width: ${maxWidth}px;
  margin: auto;
  >h1 {
    padding: 100px 0 60px;
    text-align: center;
    font-size: 36px;
    font-weight: 700;
    color: #2b2f37;
    line-height: 42px;
  }
  >ul {
    width: 400px;
    height: 50px;
    margin: auto;
    border-radius: 60px;
    background: #F5F5F5;
    color: #666666;
    display: flex;
    justify-content: space-around;
    align-items: center;
    position: relative;
    &:after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      border-radius: 60px;
      transition: all .3s;
      width: 50%;
      height: 50px;
      background-color: #3D6DE5;
    }
    li {
      cursor: pointer;
      width: 50%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      z-index: 2;
      &:hover {
        color: #3D6DE5;
      }
      h3 {
        font-weight: 400;
        position: relative;
        margin-bottom: 0;
        
      }
    }
    .current {
      /* background-color: #3D6DE5; */
      color: #fff;
      /* border-radius: 60px; */
      &:hover {
        color: #fff;
      }
    }
  }
  .two {
    &:after {
      left: 50%;
    }
  }
  @media (max-width: 768px) {
    width: 100%;
    >h1 {
      padding: 60px 0 30px;
    }
    >ul {
      width: calc(100% - 40px);
      margin-left: 20px;
    }
  }
`;

export default function GuideBox() {
  const [current, setCurrent] = useState('one');

  return (
    <>
      <GuideStyle>
        <h1>Guide for Trias Grant</h1>
        <ul className={current === 'two' ? 'two' : ''}>
          <li className={current === 'one' ? 'current' : ''} onClick={()=>{setCurrent('one')}}>
            <h3 className="h3">Fund a grant</h3>
          </li>
          <li className={current === 'two' ? 'current' : ''} onClick={()=>{setCurrent('two')}}>
            <h3 className="h3">Start a grant</h3>
          </li>
        </ul>
      </GuideStyle>
      {(current === 'one') ? <HowtoBox></HowtoBox> : <Startgrant></Startgrant> }
    </>
  )
}
